import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { UIRouterModule } from '@uirouter/angular';
import { UIRouterGlobals } from '@uirouter/core';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CompanyAccessService } from '../../services/company-access.service';
import {
  INTEGRATIONS_LIST_STATE,
  INTEGRATIONS_STATE,
} from '../../services/integrations/integrations-company/integrations-company.routing';

@Component({
  selector: 'settings-tabs',
  templateUrl: './settings-tabs.component.html',
  styleUrls: ['./settings-tabs.component.scss'],
  imports: [CommonModule, MatTabsModule, MatIconModule, UIRouterModule],
})
export class SettingsTabsComponent {
  constructor(
    private uiRouterGlobals: UIRouterGlobals,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
    private companyAccessService: CompanyAccessService,
    private featuresService: FeaturesService,
  ) {}

  /**
   * Each `shown()` mirrors its state's route guard exactly, so a rendered tab is always
   * reachable. Admin tabs use `hasPermission('sa ua')` (looser than `isRiseAdmin()`).
   * Billing uses `canAccessBilling()` (`sa`/`ua`/`ba`).
   */
  links = [
    {
      name: 'Company Settings',
      route: 'apps.settings.company-details',
      id: 'company-details',
      shown: () => this.userStateService.hasPermission('sa ua'),
    },
    {
      name: 'Company Users',
      route: 'apps.settings.user-list',
      id: 'user-list',
      shown: () => this.userStateService.hasPermission('sa ua'),
    },
    {
      name: 'SSO Settings',
      route: 'apps.settings.sso-settings',
      id: 'sso-settings',
      shown: () => this.userStateService.hasPermission('sa ua'),
    },
    {
      name: 'Companies & Licenses',
      route: 'apps.settings.company-licenses',
      id: 'company-licenses',
      shown: () =>
        !this.companyStateService.isRootCompanySelected() &&
        this.userStateService.hasPermission('sa ua'),
      upgrade: () => !this.companyAccessService.accessCompanyLicenses,
    },
    {
      name: 'Integrations',
      route: INTEGRATIONS_LIST_STATE,
      id: 'integrations',
      shown: () => true,
    },
    {
      name: 'Account & Billing',
      route: 'apps.settings.billing.home',
      id: 'billing-home',
      shown: () => this.userStateService.canAccessBilling(),
    },
  ];

  isLinkActive(route: string): boolean {
    const name = this.uiRouterGlobals.current?.name ?? '';
    const activeRoot =
      route === INTEGRATIONS_LIST_STATE ? INTEGRATIONS_STATE : route;
    return name === activeRoot || name.startsWith(`${activeRoot}.`);
  }

  upgradePlan() {
    this.featuresService.showUpgradePlanModal(
      FeaturesService.FEATURE_LICENSE_MANAGEMENT,
    );
  }
}
